import {
    MAIN_NAV_VISIBILITY,
    SET_PREVIEW_LINKS,
    SET_PREVIEW_VISIBILITY,
    SET_PREVIEW_CONTENT,
    SET_PREVIEW_ANCHOR_POS,
    SET_METANAV_LINKS,
    SET_REDUCED_NAV_VISIBILITY, SET_INITIAL_PREVIEW_ANCHOR_POS,
} from 'framework/vuex/mutation-types';

export default {

    /**
     * Set the main navbar visibility state
     * @param {INavigationState} state
     * @param {boolean} isVisible
     */
    [MAIN_NAV_VISIBILITY](state, { isVisible }) {
        state.mainVisible = isVisible;
    },

    /**
     * Set the link tree for the preview overlay
     * @param {INavigationState} state
     * @param {INavigationEntry[]} links
     */
    [SET_PREVIEW_LINKS](state, { links }) {
        state.previewLinks = links;
    },

    /**
     * Setting the visibility of the preview
     * @param {INavigationState} state
     * @param {boolean} isVisible
     */
    [SET_PREVIEW_VISIBILITY](state, { isVisible }) {
        state.isPreviewVisible = isVisible;
    },

    /**
     * Set preview content component
     * @param {INavigationState} state
     * @param {string} component
     * @param {*} props
     */
    [SET_PREVIEW_CONTENT](state, { component, props }) {
        state.previewContent = { component, props };
    },

    /**
     * Set the anchor to the current hovered element
     * @param {INavigationState} state
     * @param {number} x
     * @param {number} y
     */
    [SET_PREVIEW_ANCHOR_POS](state, { x, y }) {
        state.previewAnchor = {
            x: Math.round(x),
            y: Math.round(y),
        };
    }, /**
     * Set the anchor to the current hovered element
     * @param {INavigationState} state
     * @param {number} x
     * @param {number} y
     */
    [SET_INITIAL_PREVIEW_ANCHOR_POS](state, { x, y }) {
        if (!state.previewAnchor.x && !state.previewAnchor.y) {
            state.previewAnchor = {
                x: Math.round(x),
                y: Math.round(y),
            };
        }
    },


    /**
     * Set meta nav links in store
     * @param {INavigationState} state
     * @param {ILink[]} links
     * @param {ILink[]} languages
     */
    [SET_METANAV_LINKS](state, { links, languages }) {
        state.metanav.links = links;
        state.metanav.languages = languages;
    },

    /**
     * Set reduced navigation visibility state
     * @param {INavigationState} state
     * @param {boolean} isVisible
     */
    [SET_REDUCED_NAV_VISIBILITY](state, { isVisible }) {
        state.reducedNavVisibility = isVisible;
    },
};
